import { ReduxState } from '../../../../../../redux';

export const selectUserData = (state: ReduxState) => state.user.userData;
export const selectUserAttributes = (state: ReduxState) => state.user.userAttributes;
